import axios from "axios";
import { getToken } from "./token";

const request = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  // timeout: 60000,
});

request.interceptors.request.use(
  (config) => {
    // token
    const token = getToken();
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

request.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.log("error", error);
    return Promise.reject(error);
  },
);

export default request;
